import { MatIconRegistry } from '@angular/material/icon';
import { DomSanitizer } from '@angular/platform-browser';

const svgpath = './/assets/images/mat-icons/';

// Names of custom SVGs we import
export type TcsSvgIcon =
  | 'fc_unspecified'
  | 'fc_helicopter'
  | 'fc_plane'
  | 'fc_ambulance'
  | 'fc_rotorwing'
  | 'fc_fixedwing'
  | 'fc_ground'
  | 'fc_medic_bag'
  | 'fc_patient'
  | 'fc_pilot'
  | 'fc_crew';

// Names of icons we use from the Google Material Design icon font https://material.io/tools/icons/
export type TcsMatIcon =
  | 'assignment'
  | 'flight_takeoff'
  | 'local_airport'
  | 'group'
  | 'my_location';

// Combined type signature
export type TcsIcon = TcsSvgIcon | TcsMatIcon;

export type MatIconsConfiguration = {
  [mi in TcsMatIcon]: {
    icon: TcsMatIcon;
    description?: string;
  };
};

export const matIconConfig: MatIconsConfiguration = {
  assignment: {
    icon: 'assignment',
    description: 'Used for Unit Card',
  },
  flight_takeoff: {
    icon: 'flight_takeoff',
    description: 'Used for Unit Departed',
  },
  local_airport: {
    icon: 'local_airport',
    description: 'Used for Flight Plan',
  },
  group: {
    icon: 'group',
    description: 'Used for Team or Manifest',
  },
  my_location: {
    icon: 'my_location',
    description: 'Used for Position',
  },
};

export type SVGIconsConfiguration = {
  [si in TcsSvgIcon]: {
    icon: TcsSvgIcon;
    filename: string;
    description?: string;
  };
};

export const svgIconConfig: SVGIconsConfiguration = {
  fc_unspecified: {
    icon: 'fc_unspecified',
    filename: svgpath + 'help_outline-24px.svg',
  },
  fc_helicopter: {
    icon: 'fc_helicopter',
    filename: svgpath + 'helicopter.svg',
  },
  fc_plane: {
    icon: 'fc_plane',
    filename: svgpath + 'plane.svg',
  },
  fc_ambulance: {
    icon: 'fc_ambulance',
    filename: svgpath + 'emergency-ambulance.svg',
  },
  fc_rotorwing: {
    icon: 'fc_rotorwing',
    filename: svgpath + 'helicopter.svg',
  },
  fc_fixedwing: {
    icon: 'fc_fixedwing',
    filename: svgpath + 'plane.svg',
  },
  fc_ground: {
    icon: 'fc_ground',
    filename: svgpath + 'emergency-ambulance.svg',
  },
  fc_medic_bag: {
    icon: 'fc_medic_bag',
    filename: svgpath + 'medical-bag.svg',
  },
  fc_patient: {
    icon: 'fc_patient',
    filename: svgpath + 'patient.svg',
  },
  fc_pilot: {
    icon: 'fc_pilot',
    filename: svgpath + 'pilot.svg',
  },
  fc_crew: {
    icon: 'fc_crew',
    filename: svgpath + 'crew.svg',
  },
};

export function registerSVGIcons(iconRegistration: MatIconRegistry, domSanitizer: DomSanitizer) {
  Object.values(svgIconConfig).forEach((svgIcon) => {
    iconRegistration.addSvgIcon(
      svgIcon.icon,
      domSanitizer.bypassSecurityTrustResourceUrl(svgIcon.filename),
    );
  });
}
export interface IconNamespaceRegistration {
  [namespace: string]: { [name: string]: string };
}

interface IconNamespaceRegistrationResult {
  namespace: string;
  name: string;
  filename: string;
}

export function flatten(registry: IconNamespaceRegistration): IconNamespaceRegistrationResult[] {
  return Object.entries(registry).reduce<IconNamespaceRegistrationResult[]>((prev, next) => {
    const [namespace, icoObj] = next;
    const nsIcons: IconNamespaceRegistrationResult[] = Object.entries(icoObj).map(
      ([name, filename]) => {
        return {
          namespace,
          name,
          filename,
        };
      },
    );
    return [...prev, ...nsIcons];
  }, []);
}

export function registerIcons(
  iconsToRegister: IconNamespaceRegistration,
  iconRegistration: MatIconRegistry,
  domSanitizer: DomSanitizer,
) {
  const registrations = flatten(iconsToRegister);
  registrations.forEach((icon) => {
    iconRegistration.addSvgIconInNamespace(
      icon.namespace,
      icon.name,
      domSanitizer.bypassSecurityTrustResourceUrl(icon.filename),
    );
  });
}
